if (!customElements.get('jolivela-size-picker')) {
  customElements.define('jolivela-size-picker', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-size-chart-open]');
      this.closeButton = this.querySelector('[data-size-chart-close]');
      this.openChart = () => {
        if (!this.dialog.open) this.dialog.showModal();
      };
      this.closeChart = () => {
        this.dialog.close();
        this.openButton.focus();
      };
      this.onBackdrop = (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeChart();
      };
      this.openButton?.addEventListener('click', this.openChart);
      this.closeButton?.addEventListener('click', this.closeChart);
      this.dialog?.addEventListener('click', this.onBackdrop);
      this.fullChart = this.querySelector('.jolivela-full-chart');
      this.fullChartToggle = this.querySelector('[data-full-chart-toggle]');
      this.changeFullChartUnit = () => {
        const useCm = this.fullChart.dataset.unit !== 'cm';
        this.fullChart.dataset.unit = useCm ? 'cm' : 'inch';
        this.fullChartToggle.setAttribute('aria-checked', String(useCm));
        this.fullChart.querySelectorAll('[data-full-chart-unit]').forEach(body => {
          body.hidden = body.dataset.fullChartUnit !== this.fullChart.dataset.unit;
        });
      };
      this.fullChartToggle?.addEventListener('click', this.changeFullChartUnit);
    }
    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.openChart);
      this.closeButton?.removeEventListener('click', this.closeChart);
      this.dialog?.removeEventListener('click', this.onBackdrop);
      this.fullChartToggle?.removeEventListener('click', this.changeFullChartUnit);
    }
  });
}

if (!customElements.get('jolivela-selected-color')) {
  customElements.define('jolivela-selected-color', class extends HTMLElement {
    connectedCallback() {
      this.fieldset = this.closest('fieldset');
      if (!this.fieldset) return;
      this.updateLabel = () => {
        const selected = this.fieldset.querySelector('input[type="radio"]:checked');
        if (selected) this.textContent = selected.value;
      };
      this.fieldset.addEventListener('change', this.updateLabel);
      this.updateLabel();
    }
    disconnectedCallback() {
      this.fieldset?.removeEventListener('change', this.updateLabel);
    }
  });
}

if (!customElements.get('jolivela-color-list')) {
  customElements.define('jolivela-color-list', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.jolivela-more-colors');
      if (!this.button) return;
      this.toggleColors = () => {
        this.dataset.expanded = 'true';
        this.button.setAttribute('aria-expanded', 'true');
        this.button.hidden = true;
      };
      this.button.addEventListener('click', this.toggleColors);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggleColors);
    }
  });
}

if (!customElements.get('jolivela-size-measurements')) {
  customElements.define('jolivela-size-measurements', class extends HTMLElement {
    connectedCallback() {
      this.chart = JSON.parse(this.dataset.chart);
      this.fieldset = this.closest('fieldset');
      this.toggle = this.querySelector('[role="switch"]');
      this.cells = this.querySelectorAll('tbody tr > *');
      this.caption = this.querySelector('caption');
      this.updateMeasurements = () => {
        const size = this.fieldset.querySelector('input[type="radio"]:checked')?.value;
        const row = this.chart.rows.find(row => row.size === size);
        this.hidden = !row;
        if (!row) return;
        const unit = this.dataset.unit;
        this.cells[0].textContent = size;
        row[unit].forEach((value, index) => { this.cells[index + 1].textContent = value; });
        this.caption.textContent = this.dataset.caption + ' ' + size + ' (' + (unit === 'cm' ? this.dataset.cmLabel : this.dataset.inchLabel) + ')';
      };
      this.changeUnit = () => {
        const useCm = this.dataset.unit !== 'cm';
        this.dataset.unit = useCm ? 'cm' : 'inch';
        this.toggle.setAttribute('aria-checked', String(useCm));
        this.updateMeasurements();
      };
      this.fieldset.addEventListener('change', this.updateMeasurements);
      this.toggle.addEventListener('click', this.changeUnit);
      this.updateMeasurements();
    }
    disconnectedCallback() {
      this.fieldset?.removeEventListener('change', this.updateMeasurements);
      this.toggle?.removeEventListener('click', this.changeUnit);
    }
  });
}
